define((require) => {
    "use strict";

    const Action = require("editor/util/Action"),
        BreakpointGroup = require("shared/ui/breakpoint/BreakpointGroup"),
        EditorEvents = require("shared/services/EditorEvents"),
        SharedEntityType = require("ui/experienceOverview/experiencePermissions/SharedEntityType"),
        SharedEntityHelper = require("ui/experienceOverview/experiencePermissions/SharedEntityHelper");
    /**
     * Detaching from a breakpoint group differs from the default <tt>detach</tt> implementation. We cannot
     * delete the whole entry but instead, we need to reassign the experience.
     *
     * @param  {BreakpointGroup} breakpointGroup The group.
     * @param  {ExperienceModel} asset           The asset.
     * @return {Promise}                         Promise resulting when the group has been successfully saved.
     */
    function detachFromBreakpointGroup(breakpointGroup, asset) {
        const entries = breakpointGroup.get("entries"),
            identifier = asset.identifier();

        const first = entries.find((entry) => {
            const internalAsset = entry.get("asset");

            return internalAsset && internalAsset.get("id") !== identifier;
        });

        entries.each((entry) => {
            const internalAsset = entry.get("asset"),
                found = internalAsset && internalAsset.get("id") === identifier;

            if (found) {
                if (entry.get("value")) {
                    entry.set("asset", first.get("asset"));
                    entry.get("reference").resourceId = first.get("asset").get("id");
                } else {
                    entries.remove(entry);
                }
            }
        });

        return breakpointGroup.save();
    }

    /**
     * An action that deletes a variant from a group. If the
     * second last variant is deleted, we remove the whole group.
     *
     * @class DeleteVariantAction
     */
    return Action.extend({

        constructor: function(group, experienceId, project, updatedCollection) {
            this.__super();

            this._group = group;
            this._experienceId  = experienceId;
            this._project = project;
            this._updatedCollection = updatedCollection;
        },

        _performExecution: function() {

            const self = this,
                group = this._group;
            let promise = null;
            const experience = this._group.findAssetById(this._experienceId);

            // If this is the last asset, we remove this group, but keep the experience
            if (group.getNumOfAssets() === 1) {
                promise = group.destroy();
                SharedEntityHelper.movePermissions({
                    sourceID: group.get("id"),
                    sourceType: SharedEntityType.GROUP,
                    companyId: group.get("companyId"),
                    destID: experience.get("id"),
                    destType: SharedEntityType.EXPERIENCE
                });
            } else {
                // Breakpoint groups needs special attention...
                if (group instanceof BreakpointGroup) {
                    promise = detachFromBreakpointGroup(group, experience);
                } else {
                    promise = group.detach(experience);
                }

                promise.then(() => {
                    // Refresh the detached experience to stay in sync with the server.
                    experience
                        .fetch()
                        .then(() => experience.destroy());
                });
            }

            return promise
                .then(() => {
                    self._trackVariant(experience);

                    return experience;
                });
        },

        /**
         * Sends Mix Panel event for the variant.
         * @param {Experience} experience The deleted experience.
         * @private
         */
        _trackVariant: function(experience) {
            const eventProperties = {
                projectId: this._project && this._project.get("id"),
                groupId: this._group.get("id"),
                groupType: this._group.get("type"),
                groupVersion: this._group.get("version"),
                groupPushedVersion: this._group.get("pushedVersion"),
                triggerOrigin: "Delete" + this._group.get("type") + "Icon",
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion")
            };

            EditorEvents.trigger(EditorEvents.constants.DELETE_VARIANT, eventProperties);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/DeleteVariantAction.js